// ===========================================
// HOOK: useRegistrarVEPForm
// ===========================================
// Hook TanStack Form para registrar VEP

import { useForm } from '@tanstack/react-form'
import { registrarVEPSchema, type RegistrarVEPFormValues } from './registrarVEPSchema'

interface UseRegistrarVEPFormOptions {
  onSubmit?: (value: RegistrarVEPFormValues) => Promise<void>
  defaultValues?: Partial<RegistrarVEPFormValues>
}

export function useRegistrarVEPForm(options: UseRegistrarVEPFormOptions = {}) {
  const form = useForm({
    defaultValues: {
      vep_numero: '',
      vep_monto: null,
      vep_fecha_vencimiento: null,
      ...options.defaultValues,
    } as RegistrarVEPFormValues,
    validators: {
      onSubmit: registrarVEPSchema,
    },
    onSubmit: async ({ value }) => {
      if (options.onSubmit) {
        await options.onSubmit(value)
      }
    },
  })

  return { form }
}

export type UseRegistrarVEPFormReturn = ReturnType<typeof useRegistrarVEPForm>
export type RegistrarVEPForm = UseRegistrarVEPFormReturn['form']
